
//api/stores/theme-song/get
export function getThemeSong() {
    return {
        "success": true,
        "data": {
            "_id": "67e546a88f4d60325d3d41e4",
            "company": "Sparkle Star International - Inhouse",
            "__v": 0,
            "createdAt": "2025-03-27T12:38:00.749Z",
            "link": "https://open.spotify.com/track/04948IGlqY1vSh7AHbueiQ?si=aa98d572a4c74895",
            "updatedAt": "2025-03-27T12:38:00.749Z"
        }
    }
}


//api/get/coc
export function getCoc() {
    return {
        "_id": "67e546d48f4d60325d3d47ec",
        "company": "Sparkle Star International - Inhouse",
        "__v": 0,
        "createdAt": "2025-03-27T12:38:44.800Z",
        "link": "https://drive.google.com/file/d/0BxQpJntkO9GSZUVQWXUwT3N3Sjg/view?usp=drive_link&resourcekey=0-TuNvl4f3dv4b4Zc7a28GjA",
        "updatedAt": "2025-04-04T08:31:36.484Z"
    }
}

///api/stores / employee - handbook / get
export function getEmployeeHandbook() {
    return {
        "success": true,
        "data": {
            "_id": "67e546ca8f4d60325d3d46d4",
            "company": "Sparkle Star International - Inhouse",
            "__v": 0,
            "createdAt": "2025-03-27T12:38:34.524Z",
            "link": "https://drive.google.com/file/d/0BxQpJntkO9GSbS0wVWp5cTJZZkU/view?usp=sharing&resourcekey=0-uMwi9QJ1m9W5Y-gU5DLX_w",
            "updatedAt": "2025-04-04T08:08:45.428Z"
        }
    }
}

//api/stores/mission-vision/get

export function getMissionAndVision() {
    return {
        "success": true,
        "data": {
            "_id": "67e546dc8f4d60325d3d4900",
            "company": "Sparkle Star International - Inhouse",
            "__v": 0,
            "createdAt": "2025-03-27T12:38:52.122Z",
            "link": "https://drive.google.com/file/d/0BxQpJntkO9GSbS0wVWp5cTJZZkU/view?usp=drive_link&resourcekey=0-uMwi9QJ1m9W5Y-gU5DLX_w",
            "updatedAt": "2025-03-27T12:38:52.122Z"
        }
    }
}